// extracted by mini-css-extract-plugin
export var img = "BottomSection-module--img--gwOUu";
export var list = "BottomSection-module--list--NwIfJ";
export var title = "BottomSection-module--title--EA8FE";